import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Output,
  EventEmitter,
  OnDestroy, Inject
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedConstant} from '../../constants/sharedConstants';
import {ManageEmpGrpService} from '../../services/manage-emp-grp-service/manage-emp-grp.service';
import {SharedService} from '../../shared.service';
import {ToastMessageComponent} from '../toast-message/toast-message.component';
import { HttpResponse } from '@angular/common/http';
import {ConfigUrlService} from '../../services/config-url/config-url.service';
import {ManageEmployeeDataService} from '../../services/manage-employee/manage-employee-data.service';
import {interval, timer, Subscription, Observable, Subject} from 'rxjs';
import {delay, take} from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {LinkDelinkService} from '../../services/link-delink-service/link-delink-service.service';
import {  CommunicationService
  , IChannelContract, IFileDataContract, IFileRemoveContract,
  IFileUploadResultContract, Env, IRehydrateContract, IFileRehydrateContract, IFileNameTruncateContract, IWidgetFocusContract, IErrorDisplayContract, IFileTooltip   } from '@schwab/safeui';
import { UUID } from 'angular2-uuid';
@Component({
  selector: 'ems-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss']
})
export class BulkUploadComponent implements OnInit, AfterViewChecked, OnDestroy {
  channelDetails: IChannelContract;
  filesResult: IFileUploadResultContract[] = [];
  filesRemoved: IFileRemoveContract[] = [];
  reHydrateData: IRehydrateContract;
  fileNameTruncate: IFileNameTruncateContract;
  widgetFocus: IWidgetFocusContract;
  errorDisplay: IErrorDisplayContract;
  tooltipConfig: IFileTooltip; 
  @Input() getOrgId: any;
  @Input() isMasterGroupUpload = false;
  @Input() lib: any;
  @Input() downloadTemplate: any;
  @Input() uploadFileApi: any;
  @Input() parentPage: any;
  @Input() createdName: any;
  @Input() groupDesc: any;
  @Input() downloadTemplateName: any;
  @Input() downloadTemplateLabel: any;
  @Input() bulkUploadTitles: any;
  @Input() linkType: any;
  @Input() downloadTemplateGutTack: any;
  @Input() chooseFileGutTack: any;
  @Input() uploadBtnGutTack: any;
  @Output() FileUploadEmit: any = new EventEmitter();
  @Output() hasFormValuesChanged: any = new EventEmitter();
  sharedEnv: any;
  sharedConstant = SharedConstant;
  isFileUploaded = false;
  showError = false;
  showUploadError = false;
  uploadedFilesize: any;
  subscription: Subscription;
  errorMessage: any;
  fileName: any;
  files: any[] = [];
  uploadedFile: any[] = [];
  fileData: any;
  displayFileName: any;
  downloadURL: any;
  uploadResponse: any = [];
  isModalOpen = false;
  modalTitle = this.sharedConstant.bulkUpload.uploadErrorsTxt;
  successMsg: any;
  RequestInterval: any;
  uploadErrorMsg: any;
  uploadID: any;
  currentOrgSubscription: Subscription;
  externalAccess = false;
  public masterAccountOptions: any[];
  usertype: any;
  @ViewChild(ToastMessageComponent, { static: true }) msgToast: ToastMessageComponent;
  @ViewChild('fileUploader') localUploader: ElementRef;
  uploadedEmit: any = {};
  configURL = this.config.setApplicationUrl();
  cols: any;
  fileProcessStatus: any;
  fileUploadStatus: any = false;
  showSuccessInfoMsg: any = false;
  uploadErrorFileMsg: any;
  addlinkSuccessMsg: any;
  authorizedAgents: any;
  isAuthAgentRole: boolean;
  public BulkUploadForm: UntypedFormGroup;
  is10b5Client = false;
  showPlanIDField = false;
  planIDTxt = 'planId';
  countOfSL = 0;
  showRemarksTxtboxCharLimit: boolean;
  public businessUnit: any;
  clientId: any;
  isAAExceptBU: boolean;
  clientInfo: any;
  linkMethod: any;
  showClient: any = false;
  hasADDLinkAccess = false;
  uploadText: string;
  uploadButtonText: string;
  initialValues: any;
  token: any;
  overrideWidgetErrors = true;
  uuidValue: any;

  constructor(public commService: CommunicationService, public linkDelinkService: LinkDelinkService, private formBuilder: UntypedFormBuilder, @Inject('entitlementConst') public entitlementConst,
              private router: Router, public sharedSer: SharedService,
              private changeDetector: ChangeDetectorRef, private r: ActivatedRoute, private manageEmpGrpService: ManageEmpGrpService,
              public config: ConfigUrlService, private manageEmployeeDataService: ManageEmployeeDataService, @Inject('commonConstants') public commonConstants) {
    this.sharedEnv = this.sharedSer.env;
    this.cols = [
      {field: 'rowNumber', header: 'Row Number'},
      {field: 'status', header: 'Status'},
      {field: 'rawData', header: 'rawData'},
      {field: 'data', header: 'failMessages'},
    ];
    this.uuidValue = UUID.UUID();
  }

  ngOnDestroy() {
    if (this.RequestInterval && this.RequestInterval._subscriptions && this.RequestInterval._subscriptions.length > 0) {
      this.RequestInterval.unsubscribe();
    }
    if (this.currentOrgSubscription) {
      this.currentOrgSubscription.unsubscribe();
    this.sharedSer.safeUpload = false;

    }
    this.commService.fileRemove$.complete();
    this.commService.browseEvent$.complete();
    this.sharedSer.disableClientSelector.next(this.sharedSer.ClientCount === this.sharedConstant.clientCount);
  }

  ngAfterViewChecked() {
    if (this.linkMethod === this.sharedConstant.bulkGlobal.multi && this.countOfSL === 1 && this.usertype === this.sharedConstant.bulkGlobal.internal) {
      this.BulkUploadForm.get('masterAccounts').disable({emitEvent: false});
    }
    this.changeDetector.detectChanges();
  }

  ngOnInit() {
    this.showPlanIDField = false;
    this.linkDelinkService.showRemarks = false;
    this.BulkUploadForm = this.formBuilder.group({
      masterAccounts: new UntypedFormControl([], Validators.required),
      authAgent: new UntypedFormControl([], Validators.required),
      remarks: new UntypedFormControl(''),
      planId: new UntypedFormControl(''),
      doNotShowRemarkToClient: new UntypedFormControl(false),
    });
    this.BulkUploadForm.valueChanges.subscribe(x => {
      this.hasFormValuesChanged.emit(this.formHasChanged());
    });
    this.linkDelinkService.authAgentValidation(this.BulkUploadForm);
    this.usertype = this.sharedSer.isInternalApp() ? 'Internal' : 'External';
    this.sharedSer.selectedMasterAccnt.subscribe(value => {
      if (value && value.some(accnt => accnt.accountSubType && accnt.accountSubType.indexOf('10b5-1') !== -1)) {
        this.BulkUploadForm.get('planId').reset();
        this.showPlanIDField = true;
      } else {
        this.BulkUploadForm.get('planId').reset();
        this.showPlanIDField = false;
      }
      /* If selected Account is 10b5-1 MasterAccount adding validators to formControlName-PlanId */
      if (this.showPlanIDField && this.is10b5Client) {
        this.BulkUploadForm.controls[this.planIDTxt].setValidators(Validators.required);
        this.BulkUploadForm.controls[this.planIDTxt].updateValueAndValidity();
      } else {  /* If selected Account is not a 10b5-1 MasterAccount removing validators to formControlName-PlanId */
        this.BulkUploadForm.controls[this.planIDTxt].clearValidators();
        this.BulkUploadForm.controls[this.planIDTxt].updateValueAndValidity();
      }
      this.initialValues = this.BulkUploadForm.getRawValue();
      this.hasFormValuesChanged.emit(this.formHasChanged());
    });

    this.currentOrgSubscription = this.sharedSer.clientInformation.subscribe(clientInfo => {
      if (clientInfo !== null) {
        this.businessUnit = clientInfo.businessUnit;
        this.hasADDLinkAccess = this.sharedSer.checkEntitlements(this.entitlementConst.navUUID.accountLinking.uuid, '', '');
        this.getOrgId = clientInfo.orgId;
        this.sharedSer.getOrgId = clientInfo.orgId;
        clientInfo.externalAccess === 'Y' ? this.externalAccess = true : this.externalAccess = false;
        this.clientId = clientInfo.clientId;
        this.clientInfo = clientInfo;
        this.linkMethod = clientInfo.linkType === 'Dual' ? 'Multi' : clientInfo.linkType;
        this.is10b5Client = clientInfo.tenB51;
        this.showPlanIDField = false;
        this.closeInfo();
        this.BulkUploadForm.get('masterAccounts').setValue([]);
        this.BulkUploadForm.get('authAgent').setValue([]);
        this.BulkUploadForm.get('remarks').setValue('');
        this.countOfSL = 0;
        if (this.clientId !== null && this.lib === 'ADDLINK') {
          this.processMasterAcc();
        }
        this.initialValues = this.BulkUploadForm.getRawValue();
        this.hasFormValuesChanged.emit(this.formHasChanged());
      }
      if (this.hasADDLinkAccess && this.usertype !== 'Internal') {
        this.isAuthAgentRole = true;
        this.BulkUploadForm.controls.authAgent.setValidators([]);
        this.BulkUploadForm.controls.authAgent.updateValueAndValidity();
      } else {
        this.isAuthAgentRole = false;
      }
      this.initialValues = this.BulkUploadForm.getRawValue();
      this.hasFormValuesChanged.emit(this.formHasChanged());
    });

    this.downloadURL = this.configURL.sposEndPoint + '/files/templates/' + this.downloadTemplate;
    this.addlinkSuccessMsg = this.sharedConstant.bulkUpload.addlinkSuccessMsg + ' ' + this.sharedConstant.bulkUpload.requestList;
    this.uploadText = this.sharedConstant.bulkUpload.uploadText + '<em class="highlight-color">*</em>';
    this.uploadButtonText = this.sharedConstant.bulkUpload.chooseFileText;
    this.initialValues = this.BulkUploadForm.getRawValue();
    this.hasFormValuesChanged.emit(this.formHasChanged());
    this.setSafeContract();
    this.commService.browseEvent$ = new Subject<IFileDataContract>;
    this.commService.fileRemove$ = new Subject<IFileRemoveContract>;
    this.commService.browseEvent$.subscribe(fileData => this.handleFileBrowse(fileData));
    this.commService.fileRemove$.subscribe(res => this.handleFileRemove(res));
   }

  processMasterAcc() {
    if (this.hasADDLinkAccess) {
      this.linkDelinkService.getLinkMasterAccounts(this.getOrgId, this.clientId).subscribe(result => {
        const getMasterAccData: any = this.linkDelinkService.populateMasterAccounts(this.BulkUploadForm, this.clientId, this.linkMethod, this.countOfSL, this.usertype, result.data);
        this.masterAccountOptions = getMasterAccData.masterAccountOptions;
        this.countOfSL = getMasterAccData.countOfSL;
        if (this.usertype === 'External' && this.countOfSL === 1) {
          this.showPlanIDField = this.is10b5Client;
          if (this.showPlanIDField) {
            this.BulkUploadForm.controls[this.planIDTxt].setValidators(Validators.required);
            this.BulkUploadForm.controls[this.planIDTxt].updateValueAndValidity();
          }
        }
        this.initialValues = this.BulkUploadForm.getRawValue();
        this.hasFormValuesChanged.emit(this.formHasChanged());
      });

      this.linkDelinkService.getAuthorizedAgents(this.getOrgId).subscribe(result => {
        this.businessUnit = result.data.authAgentExceptionBusinesUnits;
        this.isAAExceptBU = this.linkDelinkService.populateAuthorizedAgents(this.businessUnit, this.clientInfo);
        if (this.isAAExceptBU) {
          this.BulkUploadForm.controls.authAgent.enable();
          this.authorizedAgents = this.linkDelinkService.getAuthAgents(this.clientId, result.data);
        } else {
          this.BulkUploadForm.controls.authAgent.disable();
        }
        this.initialValues = this.BulkUploadForm.getRawValue();
        this.hasFormValuesChanged.emit(this.formHasChanged());
      });
    }
  }


  cancelFileUpload() {
    this.router.navigate([this.parentPage]);
  }

  closeInfo() {
    this.onClose('close');
    this.successMsg = null;
    this.fileProcessStatus = null;
  }

  /*closing the Upload Error Modal*/
  onClose(data) {
    this.showSuccessInfoMsg = false;
    this.isFileUploaded = false;
    this.isModalOpen = false;
    this.errorDisplay = {
      showBannerError: true,
      showInlineError: false
    };
      
    this.uploadedEmit = {
      isFileUploaded: this.isFileUploaded,
      showError: this.showError,
    };
    this.FileUploadEmit.emit(this.uploadedEmit);
    this.hasFormValuesChanged.emit(this.formHasChanged());
  }

 uploadFile() {
    this.uploadResponse = [];
    const formData = new FormData();
    if (this.lib === 'ADDLINK') {
      const masterAccountNbr = [];
      const masterAccounts: any =  this.BulkUploadForm.get('masterAccounts').value;
      for (const masterAccount of masterAccounts) {
        masterAccountNbr.push(masterAccount.value);
      }
      const authagentVal = this.isAAExceptBU && this.BulkUploadForm.get('authAgent').value.length > 0 ? this.BulkUploadForm.get('authAgent').value[0].label : '';
      const uploadInfo = {
        uploadType: 'ADDLINK',
        fileName: this.reHydrateData.files.map(a => a.name).toString(),
        safeId: this.reHydrateData.files.map(a => a.safeId).toString(),
        // showRemarkToClient will be Y when checkbox is checked
        data: {
          authAgentFN: authagentVal ? authagentVal.split(',')[1].trim() : '',
          authAgentLN: authagentVal ? authagentVal.split(',')[0].trim() : '',
          orgId: this.getOrgId,
          jobName: 'AddlinkUpload',
          masterAccountNbrList: masterAccountNbr,
          remark: this.BulkUploadForm.get('remarks').value,
          showRemarkToClient: this.BulkUploadForm.get('doNotShowRemarkToClient').value ? 'Yes' : 'No',
          planId: this.BulkUploadForm.get('planId').value,
        }
      };
       
      formData.append('uploadInfo ', JSON.stringify(uploadInfo));
      this.uploadeFile(formData, uploadInfo);
    } else if (this.lib === 'EMPLOYEE') {
      const uploadInfo = {
        uploadType: 'EMPLOYEE',
        fileName: this.reHydrateData.files.map(a => a.name).toString(),
        safeId: this.reHydrateData.files.map(a => a.safeId).toString(),
        data: {
          orgId: this.getOrgId,
          jobName: 'EmpUpload'
        }
      };
      formData.append('uploadInfo ', JSON.stringify(uploadInfo));
      this.uploadeFile(formData, uploadInfo);
    } else if (this.lib === 'EMPLOYEEGROUP') {
      const uploadInfo = {
        uploadType: 'EMPLOYEEGROUP',
        fileName: this.reHydrateData.files.map(a => a.name).toString(),
        safeId: this.reHydrateData.files.map(a => a.safeId).toString(),
        data: {
          orgId: this.getOrgId,
          jobName: this.businessUnit ? this.sharedConstant[this.businessUnit].groupOrPartcUploadTemplate : 'EMPLOYEEGROUP',
          groupName: this.createdName,
          groupDesc: this.groupDesc
        }
      };
      formData.append('uploadInfo ', JSON.stringify(uploadInfo));
      this.uploadeFile(formData, uploadInfo);
    } else if (this.lib === 'MASTERGROUP') {
      const uploadInfo = {
        uploadType: 'MASTERGROUP',
        fileName: this.reHydrateData.files.map(a => a.name).toString(),
        safeId: this.reHydrateData.files.map(a => a.safeId).toString(),
        data: {
          orgId: this.getOrgId,
          jobName: 'MasterGroupUpload',
          groupName: this.createdName,
          groupDesc: this.groupDesc
        }
      };
      formData.append('uploadInfo ', JSON.stringify(uploadInfo));
      this.uploadeFile(formData, uploadInfo);
    } else if (this.lib === 'RULE') {
      const uploadInfo = {
        uploadType: 'RULE',
        fileName: this.reHydrateData.files.map(a => a.name).toString(),
        safeId: this.reHydrateData.files.map(a => a.safeId).toString(),
        data: {
          orgId: this.getOrgId,
          jobName: 'RuleUpload'
        }
      };
      formData.append('uploadInfo ', JSON.stringify(uploadInfo));
      this.uploadeFile(formData, uploadInfo);
    }
  }

  uploadeFile(data, uploadInfo?) {
    this.sharedSer.uploadFile(data, uploadInfo).subscribe((response: any) => {
      if (response && response.errorMessage === 'null') {
        response.errorMessage = null;
      }
      this.uploadResponse = response;
      this.uploadID = response.data;
      this.uploadErrorHandling();
    });
  }

  uploadErrorHandling() {
    if (this.uploadResponse.success === true) {
      this.uploadErrorFileMsg = '';
      this.fileUploadStatus = true;
      this.showSuccessInfoMsg = true;
      this.successMsg = this.sharedConstant.bulkUpload.fileReceived;
      setTimeout(() => {
        this.navigateToUplodsList();
      }, 2000);
    } else {
      this.fileUploadStatus = false;
      /* Set isDTBtnClicked value to true, generate the data track value with 'linkid-lc' . */
      this.sharedSer.isDTBtnClicked = true;
      this.sharedSer.loadDataTrackValue(this.uploadBtnGutTack);
      this.sharedSer.loadSpsPageCall();

      this.uploadErrorFileMsg = this.uploadResponse.failMsg;
      this.showUploadError = true;
      this.fileProcessStatus = null;
      this.showSuccessInfoMsg = false;
    }
  }


  downloadFileSystem() {
    this.sharedSer.safeUpload = false;
    this.sharedSer.gutTracking(this.downloadTemplateGutTack);
    this.sharedSer.downloadFileSystem(this.downloadTemplate, 'spos')
      .subscribe((response: HttpResponse<Blob>) => {
        let filename = '';

        if (this.downloadTemplate === 'RULE') {
          filename = this.sharedConstant.bulkUpload.rulesTempFileName;
        } else if (this.downloadTemplate === 'EMPGROUP') {
          filename = this.sharedConstant.bulkUpload.empGrpTempFileName;
        } else if (this.downloadTemplate === 'MASTERGROUP') {
          filename = this.sharedConstant.bulkUpload.masterGrpTempFileName;
        } else if (this.downloadTemplate === 'PARTICIPANT') {
          filename = this.sharedConstant.bulkUpload.planTempFileName;
        } else if (this.downloadTemplate === 'EMP') {
          filename = this.sharedConstant.bulkUpload.empTempFileName;
        } else if (this.downloadTemplate === 'ADDLINKDBSINT' || this.downloadTemplate === 'ADDLINKDBSEXT' || this.downloadTemplate === 'ADDLINKSPS') {
          filename = this.sharedConstant.bulkUpload.addlinkTemplate;
        } else if (this.downloadTemplate === 'RULESPSEXT') {
          filename = this.sharedConstant.bulkUpload.rulesExtTemplate;
        } else {
          filename = 'random-file.xslx';
        }

        this.sharedSer.saveFile(response.body, filename);
      });
  }

  navigateToUplodsList() {
    this.router.navigate(['/ems/uploads/uploads-list'], {relativeTo: this.r});
  }

  public populateAuthorizedAgents(): void {
    this.authorizedAgents = [];
    this.linkDelinkService.populateAuthorizedAgents(this.businessUnit, this.clientInfo);
  }

  formHasChanged(): boolean {
    if (this.initialValues) {
      const hasformChanged = Object.entries(this.initialValues).some(
        ([field, value]) => {
          if (Array.isArray(value)) {
            // check for Empty array as [] === [] will give you false
            if ((this.initialValues[field].length === 0 && this.BulkUploadForm.getRawValue()[field].length === 0)) {
              return false;
            } else {
                return value.length !== this.BulkUploadForm.getRawValue()[field].length;
            }
          } else {
            const initialValue = value || '';
            const formValue = this.BulkUploadForm.getRawValue()[field] || '';
            return initialValue !== formValue;
          }
        }
      );
      return hasformChanged;
    } else {
      return false;
    }
  }

  removeLeadingZeroes() {
    const value = this.BulkUploadForm.getRawValue().planId ? this.BulkUploadForm.getRawValue().planId.toString().replace(/^0+/, '') : '';
    this.BulkUploadForm.get('planId').setValue(value);
    if (value === '0') {
      this.BulkUploadForm.get('planId').reset();
    }
  }

  private checkErrors(file: IFileUploadResultContract) {
    if (file.errorMsg !== null) {
      this.showError = true;
      this.errorMessage = file.errorMsg;
      }

}

  setFileMetadata(fileData: IFileDataContract) {
    if (this.lib === 'ADDLINK') {
      fileData.fileMetadata.fileArtifactType = 'ADDLink';
    } else if (this.lib === 'RULE') {
      fileData.fileMetadata.fileArtifactType = 'Rule';
    } else if (this.lib === 'EMPLOYEEGROUP') {
      fileData.fileMetadata.fileArtifactType = 'EmployeeGroup';
    } else if (this.lib === 'MASTERGROUP') {
      fileData.fileMetadata.fileArtifactType = 'MasterGroup';
    } else if (this.lib === 'EMPLOYEE') {
      fileData.fileMetadata.fileArtifactType = 'Employee';
    }
    fileData.securityToken = `Bearer ${localStorage.getItem('token')}`;
    fileData.displayFileSize = false;
    this.commService.pubishFileMetadata(fileData);
  }

  handleFileBrowse(fileData: IFileDataContract): void {
    this.sharedSer.safeUpload = true;
    this.isFileUploaded = true;
    this.sharedSer.clearErrorMessage();
    this.sharedSer.gutTracking(this.chooseFileGutTack);
    this.setFileMetadata(fileData);
    if (this.reHydrateData === undefined) {
      this.reHydrateData = {} as IRehydrateContract;
      this.reHydrateData.token = `Bearer ${localStorage.getItem('token')}`;
    }
    this.commService.fileUploadResult$.pipe(take(1)).subscribe((result: IFileUploadResultContract) => {
      // result is a IFileUploadResultContract which provides the file upload success, failure and error details.
      //Read Rehydration Data from Response
      if ((this.reHydrateData !== undefined && this.reHydrateData.files === undefined) || this.showError) {
        this.reHydrateData.files = [];
      }
      if (this.reHydrateData !== undefined && this.reHydrateData.files !== undefined) {
        this.reHydrateData.files.push(result.fileRehydrateContract);
      }
      this.showError = false;
      this.showUploadError = false;
      this.uploadErrorFileMsg = '';
      this.errorMessage = '';
      if (this.overrideWidgetErrors) {
        this.checkErrors(result);
      }
      this.filesResult.push(result);
      this.errorDisplay = {
        showBannerError: true,
        showInlineError: false
      };
        
      this.uploadedEmit = {
        showError: this.showError,
        validFile: this.lib === 'ADDLINK' ? this.BulkUploadForm.valid : true,
      };
      this.FileUploadEmit.emit(this.uploadedEmit);
      if (result.errorMsg === null) {
        this.hasFormValuesChanged.emit(false);
        this.uploadFile();
      }
    });
  }

private handleFileRemove(res: IFileRemoveContract): void {
  if (res.safeId && res.isRemoved) {
    this.reHydrateData.files.length = 0;
    this.reHydrateData = {} as IRehydrateContract;
    this.filesResult.length = 0;
    this.isFileUploaded = false;
    this.fileName = '';
    this.sharedSer.clearErrorMessage();
      this.showError = false;
      this.showUploadError = false;
      this.uploadErrorFileMsg = '';
    this.uploadedEmit = {
      showError: this.showError,
      validFile: this.lib === 'ADDLINK' ? this.BulkUploadForm.valid : true,
    };
    this.FileUploadEmit.emit(this.uploadedEmit);
    this.hasFormValuesChanged.emit(this.formHasChanged());
}
}

private setSafeContract(): void {
  this.channelDetails = {
    clientAppId: 'AD00007233',
    clientCorrelId: this.uuidValue,
    env: Env[this.sharedSer.domainValue as keyof typeof Env],
    configureLinks: {
              showRemoveFileLink: false
          }    
    };

  this.errorDisplay = {
    showBannerError: true,
    showInlineError: false
  };
}

}